import { CongThucDinhMucService } from './../../cong-thuc-dinh-muc/cong-thuc-dinh-muc-service/cong-thuc-dinh-muc.service';
import { QuyTrinhSanXuatService } from './../../quy-trinh-san-xuat/quy-trinh-san-xuat-service/quy-trinh-san-xuat.service';
import { BOMCt, __DEFAULT__DSP, TreeBTP, LoopGiaiDoan, BOM, ListStep3, DisplayColumnsExtend } from '../bom-model/bom.model';
import { BOMBtpDialogComponent } from '../bom-btp-dialog/bom-btp-dialog.component';
import { BOMService } from '../bom-service/bom.service';
import { DungChungService } from 'app/views/pages/nfc/dung-chung/__services/dung-chung.service';
import { Component, OnInit, Input, ChangeDetectionStrategy, HostListener, ElementRef, ViewChild, ChangeDetectorRef, ViewRef, Output, EventEmitter } from '@angular/core';
import { Observable, fromEvent, of, BehaviorSubject, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, tap, debounceTime } from 'rxjs/operators';
import { Moment } from 'moment';
import * as moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TokenStorage } from 'app/core/auth/_services/token-storage.service';
import { LayoutUtilsService } from 'app/core/_base/crud/utils/layout-utils.service';
import { RdBoM, RdBoMCt } from '../../cong-thuc-dinh-muc/cong-thuc-dinh-muc-model/cong-thuc-dinh-muc.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { SelectionModel } from '@angular/cdk/collections';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { MatDialog, MatSort, MatTableDataSource } from '@angular/material';
import { __DEFAULT__IDLOAIHH } from '../bom-model/bom.model';
import { number } from '@amcharts/amcharts4/core';
import { QueryParamsModel } from 'app/core/_base/crud/models/query-models/query-params.model';

@Component({
	selector: 'kt-bom-step-three',
	templateUrl: './bom-step-three.component.html',
	styleUrls: ['../bom.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class BOMStepThreeComponent implements OnInit {
	CONFIG: CommonConFig;
	@ViewChild('sort1', {static: true}) sort: MatSort;
	public __InputListBTP: any[] = [];
	@Input() set InputListBTP(value: any[]) { 
		this.__InputListBTP = value; 
		this.setGiaiDoan(); 
		this.setTableNSTNCN(); 
		this.getListThietBiLite();  
		this.setTableNSTBTB(); 
	}
	@Input() edit : boolean = false;
	@Output() OutputNSTBNC = new EventEmitter<any[]>();
	@Output() OutputNSTBTB = new EventEmitter<any[]>();
	displayNameNSTBCN = ['MAHH', 'TENHH', 'GIAIDOAN', 'NSTBCN'];
	dataSourceNSTB: any[] = [];
	displayNameNSTBTB__Header = [{code : 'MATEN', name : 'BTP/TP', columns: '2'}];
	displayNameNSTBTB__Title  = [{code : 'CODE', name : 'Mã', value: 'Ma'},{code : 'NAME', name : 'Tên', value: 'Ten'}];
	dataSourceNSTBTB: any[]   = [];
	listKVSX : any[] = [];
	selectKVSX : string = '';
	filteredKVSX: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	sumRecordKVSX = 0;
	KVSXFilterCtrl: string = '';
	haveElementKVSX: boolean = false;
	listPXSX : any[] = [];
	selectPXSX : string = '';
	filteredPXSX: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	sumRecordPXSX = 0;
	PXSXFilterCtrl: string = '';
	haveElementPXSX: boolean = false;
	ListKhuVuc : ListStep3[] = [];
	dataGiaiDoan = [];
	ListGiaiDoan = [];
	constructor(
        private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private service: BOMService,
		private serviceQTSX : QuyTrinhSanXuatService,
		private serviceCTDM : CongThucDinhMucService,
		public dialog: MatDialog,
    ) { }

	ngOnInit(): void {
		this.CONFIG = new CommonConFig();
		this.GetSoGiaiDoan();
		this.setGiaiDoan();
		this.setTableNSTNCN();
		this.setTableNSTBTB();
		this.getListThietBiLite();
		this.changeDetectView();
	}

	setGiaiDoan(){
		this.dataGiaiDoan = [];
		this.__InputListBTP.forEach(x => {
			var rObj = {};
			rObj["IdGiaiDoan"] = x.IdGiaiDoan;
			rObj["TenGiaiDoan"] = x.TenGiaiDoan;
			rObj["displayNameNSTBTB__Header"] = [{code : 'MATEN', name : 'BTP/TP', columns: '2'}];;
			rObj["displayNameNSTBTB__Title"] = [{code : 'CODE', name : 'Mã', value: 'Ma'},{code : 'NAME', name : 'Tên', value: 'Ten'}];
			if(this.dataGiaiDoan.findIndex(x => x.IdGiaiDoan == rObj["IdGiaiDoan"]) == -1){
				this.dataGiaiDoan.push(rObj);
			}
		});
		this.dataGiaiDoan = [...new Set(this.dataGiaiDoan)];
		this.changeDetectView();
	}
	
	setTableNSTNCN(){
		this.dataSourceNSTB = [];
		this.__InputListBTP.forEach(x => {
			var rObj = {};
			rObj["Id"] = x.IdBTP;
			rObj["Ma"] = x.MaBTP;
			rObj["Ten"] = x.TenBTP;
			rObj["IdGiaiDoan"] = x.IdGiaiDoan;
			rObj["TenGiaiDoan"] = x.TenGiaiDoan;
			rObj["NSTBCN"] = x.NSTBCN ? x.NSTBCN : null;
			rObj["HieuSuat"] = x.HieuSuat;
			this.dataSourceNSTB.push(rObj);
		});
		this.dataSourceNSTB = [...this.dataSourceNSTB];
		this.changeDetectView();
	}

	setTableNSTBTB(){
		this.dataSourceNSTBTB = [];
		this.__InputListBTP.forEach(x => {
			var rObj = {};
			rObj["Id"] = x.IdBTP;
			rObj["Ma"] = x.MaBTP;
			rObj["Ten"] = x.TenBTP;
			rObj["IdGiaiDoan"] = x.IdGiaiDoan;
			rObj["TenGiaiDoan"] = x.TenGiaiDoan;
			rObj["Data"] = [];
			
			this.dataSourceNSTBTB.push(rObj);
		});
		this.dataSourceNSTBTB = [...this.dataSourceNSTBTB];
		this.changeDetectView();
	}

	findBTPWithGiaiDoan(IdGiaiDoan: number){
		var data = this.dataSourceNSTBTB.length > 0 ?  this.dataSourceNSTBTB.filter(x => x.IdGiaiDoan == IdGiaiDoan): [];
		return data;
	}

	findCodeTable(data: []){
		return data.map(x => x["code"]);
	}

    f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}

	getListThietBiLite(){
		if(this.__InputListBTP.length > 0){
			this.serviceCTDM.getListAllThietBiWithIdTP(this.__InputListBTP[this.__InputListBTP.length - 1].IdBTP).subscribe(res => {
				if(res && res.status == 1){
					if(res.data){
						this.dataGiaiDoan.forEach(gd => {
							gd["displayNameNSTBTB__Header"] = [];
							gd["displayNameNSTBTB__Title"] = [];
							gd["displayNameNSTBTB__Header"] = [{code : 'MATEN', name : 'BTP/TP', columns: '2'}];
							gd["displayNameNSTBTB__Title"] = [{code : 'CODE', name : 'Mã', value: 'Ma'},{code : 'NAME', name : 'Tên', value: 'Ten'}];
							var __item = res.data.filter(x => x.IdGiaiDoan == gd.IdGiaiDoan);
							__item.forEach(__z => {
								if(gd["displayNameNSTBTB__Header"].length > 0 && gd["displayNameNSTBTB__Header"].map(x => x.code).length > 0){
									if(gd["displayNameNSTBTB__Header"].filter(a => a.code == "KHUVUC"+__z.IdKhuVuc).length == 0){
										gd["displayNameNSTBTB__Header"].push({code : "KHUVUC"+__z.IdKhuVuc, 
																		name : __z.TenKhuVuc, 
																		columns : this.sumThietBiInKhuVuc(__z.IdKhuVuc, res.data, __z.IdGiaiDoan)
																		});
									}
								}else{
									gd["displayNameNSTBTB__Header"].push({code : "KHUVUC"+__z.IdKhuVuc, 
																		name : __z.TenKhuVuc, 
																		columns : this.sumThietBiInKhuVuc(__z.IdKhuVuc, res.data,  __z.IdGiaiDoan)
																		});
								}

								if(gd["displayNameNSTBTB__Title"].length > 0 && gd["displayNameNSTBTB__Title"].map(x => x.code).length > 0){
									if(gd["displayNameNSTBTB__Title"].filter(a => a.code == "THIETBI"+__z.IdThietBi).length == 0){
										gd["displayNameNSTBTB__Title"].push({code : "THIETBI"+__z.IdThietBi+__z.IdKhuVuc+gd["displayNameNSTBTB__Title"].length,
																					name  : __z.TenThietBi,
																					id : __z.IdThietBi,
																					value : "Input"});
									}
								}else{
									gd["displayNameNSTBTB__Title"].push({code : "THIETBI"+__z.IdThietBi+__z.IdKhuVuc+gd["displayNameNSTBTB__Title"].length,
																					name  : __z.TenThietBi,
																					id : __z.IdThietBi,
																					value : "Input"});
								}
							});
							var data = this.dataSourceNSTBTB.length > 0 ?  this.dataSourceNSTBTB.filter(x => x.IdGiaiDoan == gd.IdGiaiDoan): [];
							var __d = this.dataGiaiDoan.find(a => a.IdGiaiDoan == gd.IdGiaiDoan);
							if(__d && data.length > 0){
								var tb = __d.displayNameNSTBTB__Title.filter(x => x.value == "Input");
								var tmp = [];
								tb.forEach(t => {
									var Obj = {};
									Obj["IdThietBi"] = t.id,
									Obj["NSTBTB"] = null;
									tmp.push(Obj);
								});
								data.forEach(z => {
									z.Data = tmp;
								});
							}
						})
						
					}
					var listNSTBTBAPI = this.__InputListBTP.map(x => x.NSTBTB).reduce((a,b) => a.concat(b));
					this.dataSourceNSTBTB.forEach(x => {
						var i = listNSTBTBAPI.filter(a => a.IdGiaiDoan == x.IdGiaiDoan && a.IdBTP == x.Id);
						i.forEach(api => {
							x.Data.forEach(cli => {
								if(cli.IdThietBi == api.IdThietBi) cli.NSTBTB = api.DinhMuc;
							});
						});
					});
					this.dataSourceNSTBTB = [...this.dataSourceNSTBTB];
					this.dataGiaiDoan = [...new Set(this.dataGiaiDoan)];
					this.changeDetectView();
				}
			});
		}
	}

	sumThietBiInKhuVuc(IdKhuVuc: number, data: any[], IdGiaiDoan: number){
		return data.filter(x => x.IdKhuVuc == IdKhuVuc && x.IdGiaiDoan == IdGiaiDoan).length;
	}
	
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

	findListPX__WithIdKV(listKhuVuc: any[]){
		var listPX = [];
		listKhuVuc.forEach(kv => {
			var rKhuVuc = {};
			rKhuVuc["IdKV"] = kv.Id;
			rKhuVuc["TenKV"] = kv.TenKhuVuc;
			rKhuVuc["ListPX"] = [];
			this.listPXSX.filter(x => x.IdParent == rKhuVuc["IdKV"]).forEach(r => {
				var rObj = {};
				rObj["IdPX"] = r.Id;
				rObj["TenPX"] = r.TenKhuVuc;
				rKhuVuc["ListPX"].push(rObj);
			});
			listPX.push(rKhuVuc);
		});
		return listPX;
	}

	changeValue(event: any, item: any, index : number, disCol: any){
		item[index] = event ? Number(event) : 0;
		this.ListKhuVuc = [...this.ListKhuVuc];
		this.outputNS();
		var IdBTPUpdate = item[0];
		var row = this.__InputListBTP.find(x => x.IdBTP == IdBTPUpdate);
		if(index == 3 && row){
			row.NSTBCN = item[index] ? item[index] : null;
		}
		if(index > 3 && row){
			row.NSTBTB.forEach(t => {
				if(t.IdThietBi == disCol.IdThietBi){
					t.DinhMuc = item[index];
				}
			});
		}
		this.OutputNSTBNC.next(this.__InputListBTP);
	}

	changeDataNSTBCN(event: any, item: any){
		if(event){
			item.NSTBCN = Number(event);
		}else{
			item.NSTBCN = null;
		}
		this.dataSourceNSTB = [...this.dataSourceNSTB];
		this.outputNS();
		this.changeDetectView();
	}

	outputNS(){
		this.OutputNSTBNC.next(this.dataSourceNSTB);
	}

	keyUpInput(event) {
		FunctionPublic.preventAlphaV2(event);
	}

	getDataNSTBTB(data: any, IdThietBi: number){
		var value = data.find(x => x.IdThietBi == IdThietBi);
		return value ? value.NSTBTB : null;
	}

	changeDataNSTBTB(event: any, data: any, IdThietBi: number){
		var value = data.find(x => x.IdThietBi == IdThietBi);
		if(value){
			if(event)
				value.NSTBTB = Number(event);
			else 
				value.NSTBTB = null;
		}
		this.dataSourceNSTBTB = [...this.dataSourceNSTBTB];
		this.OutputNSTBTB.next(this.dataSourceNSTBTB);
		this.changeDetectView();
	}

	async GetSoGiaiDoan() {
		let res = await this.service.GetSoGiaiDoan().toPromise();
		if (res && res.status === 1) {
			this.ListGiaiDoan = res.data;
			this.changeDetectView();

		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}
	}

	is_first(id_gd: number){
		return this.ListGiaiDoan.findIndex(x => x.QtsxGiaidoanId == id_gd) == 0;
	}
}
